/**
 * Map từ RefType sang tên form chi tiết
 * Mục đích tạo file này là do 1 file Detail có thể chứa 2 reftype
 * NXCHIEN 19.05.2022
 */
export default {
  BUTransferDetail: 56, // Chuyển khoản kho bạc vào TK tiền gửi
  BUTransferDepositDetail: 561, // Chuyển khoản kho bạc vào TK tiền gửi
  BUPlanWithdrawDepositDetail: 562, // Rút dự toán tiền gửi
  BUPlanWithdrawCashDetail: 54, // Rút dự toán tiền mặt
  BUPlanWithdrawTransferDetail: 55, // Rút dự toán chuyển khoản
  BUPlanWithdrawSalaryTransferDetail: 563, // Rút dự toán chuyển khoản lương, bảo hiểm
  BUPlanReceiptDetail: [51, 52], //Nhận dự toán đầu năm  NOTE: 51 52 dùng chung form Detail đặt tên giống nhau
  CAReceiptPlanWithdrawDetail: 105, // Phiếu thu rút dự toán nhập quỹ
  CAReceiptDetail: 101, // Phiếu thu rút dự toán nhập quỹ
  CAReceiptSaleDetail: [102, 154], // Phiếu thu bán hàng
  CAReceiptWithdrawDetail: 114, //Phiếu thu rút tiền gửi ngân hàng, kho bạc
  BUPlanCancelDetail: 69, // Hủy dự toán,
  BUVoucherListPlannedDetail: 63, // Bảng kê chứng từ thanh toán đã cấp dự toán
  BUVoucherListNotPlannedDetail: 64, // Bảng kê chứng từ thanh toán chưa cấp dự toán
  BUVoucherListReceipExpenseDetail: 65, // Bảng kê chứng từ thanh toán ghi thu - ghi chi
  BUVoucherListOtherDetail: 66, // Bảng kê chứng từ khác
  BUVoucherListRealExpenseDetail: 70, // Bảng kê chứng từ thanh toán thực chi
  BUPlanAdjustmentDetail: 53, //Điều chỉnh dự toán
  SUTransferDetail: 207, // Điều chuyển CCDC
  SUIncrementDetail: 205, // Ghi tăng CCDC
  SUDecrementDetail: 206, // Ghi giảm CCDC
  BUExpenseWithdrawAdjustmentDetail: 652, // Điều chỉnh kinh phí
  BURealExpenseAdjustmentDetail: 654, // Điều chỉnh thực chi
  PUInvoiceDetail: 301, // Mua hàng chưa thanh toán (Hóa đơn mua hàng)
  INTransferDetail: 203, // Chuyển kho
  INAdjustmentDetail: 204, // Điều chỉnh tồn kho
  INOutwardDetail: 202, // Xuất kho
  INInwardDetail: 201, // Nhập kho
  BADepositDetail: 153, // Thu tiền gửi
  SAInvoiceDetail: 351, //Bán hàng chưa thu tiền
  BABankTransferDetail: 162, // Chuyển tiền nội bộ
  CAPaymentDetail: 106, //Phiếu chi thông thường
  CAPaymentDepositDetail: 113, // Phiếu chi nộp vào ngân hàng, kho bạc
  BAWithDrawDetail: 157, // Chi tiền gửi
  BUBudgetReserveDetail: 73, //Dự toán giữ lại
  GLGeneralVoucherDetail: 401, // Chứng từ nghiệp vụ khác
  GLEndYearTransferDetail: 402, //Kết chuyển số dư cuối năm
  GLBeginningYearTransferDetail: 403, //Quyết toán số dư đầu năm
  CAReceiptCustomerDetail: [104, 156], //Phiếu thu tiền khách hàng
  GLProfitLossTransferDetail: 404, //Xác định kết quả hoạt động
  GLProvisionalTaxInComeEnterpriseDetail: 420, //Tạm tính thuế thu nhập doanh nghiệp
  GLFinalTaxInComeEnterpriseDetail: 421, //Quyết toán thuế thu nhập doanh nghiệp
  GLVoucherSummaryTableDetail: 406, //Bảng tổng hợp chứng từ cùng loại
  SAReturnDetail: 352, //Hàng bán trả lại
  BUCommitmentRequestDetail: 71, // Đề nghị cam kết chi
  BUCommitmentAdjustmentDetail: 72, // Điều chỉnh cam kết chi
  BUOpeningCommitmentDetail: 606, // Nhập CKC ban đầu
  GLPostedVoucherDetail: 407, // Chứng từ ghi sổ
  BATransferDepositDetail: 151, //Tiền đang chuyển đến
  BATransferWithdrawDetail: 152, //Tiền đang chuyển đi
  FAVoucherDepreciationDetail: 413, // Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN
  FAVoucherIncreamentDetail: 410, // Ghi tăng TSCĐ từ QLTS.VN
  FAVoucherAdjustmentDetail: 411, // Đánh giá lại TSCĐ từ QLTS.VN
  FAVoucherDepreciateDetail: 412, // Lấy khấu hao TSCĐ từ QLTS.VN
  FAVoucherDecrementDetail: 414, // Ghi giảm TSCĐ từ QLTS.VN
  INInwardFromINAdjustmentDetail: 211, // nhập kho từ điều chỉnh tồn kho
  INInwardFromINAdjustmentChangeAmountDetail: 213, // nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  INOutwardFromINAdjustmentDetail: 212, // xuất kho từ điều chỉnh tồn kho
  INOutwardFromINAdjustmentChangeAmountDetail: 214, // xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  PUPaymentDetail: [57, 107, 158], // Mua hàng trả tiền ngay// CAPaymentPurchaseDetail: 107, // Phiếu chi mua Vật tư, hàng hóa// BAWithdrawPurchaseDetail: 158, // Chi tiền gửi mua Vật tư, hàng hóa
  BUTreasuryFundTransferSalaryDetail: 564, //Chuyển khoản lương
  BUTreasuryFundTransferInsurancePaymentDetail: 565, // Chuyển khoản thanh toán bảo hiểm
  PUVendorPaymentDetail: [59, 109, 160], //Trả tiền nhà cung cấp
  SASaleInvoiceDetail: 701, //Hóa đơn
  StatisticalDayOffDetail: 501, //Tổng hợp ngày nghỉ, làm thêm làm đêm
  PARetroSalaryIncreaseDetail: 509, // Bảng truy lĩnh lương
  PARetroStandardSalaryIncreaseDetail: 508, // Bảng truy lĩnh lương tối thiểu
  PAOtherOutcomeDetail: 506, // Khấu trừ không thường xuyên
  PAOtherIncomeDetail: 505, // Thu nhập không thường xuyên
  PASalaryDetail: 502, // bảng lương
  OPBalance: [551, 552, 553, 554, 555, 556, 557, 558, 559, 601, 604, 605], //Số dư ban đầu
  BUTransferSalaryDetail: 60, //Chuyển khoản kho bạc trả lương
  BAWithDrawSalaryDetail: 163, //Chi tiền gửi trả lương
  CAPaymentSalaryDetail: 110, // phiếu chi trả lương
  PAPersonalIncomeTaxDetail: 510, // Bảng tính thuế
  GLPayrollExpenseDetail: 405, //Hạch toán chi phí lương
  FAAdjustmentDetail: 254, // Đánh giá lại TSCĐ
  FAIncrementDetail: 252, // Nhận bằng hiện vật và ghi tăng
  FASaleInvoiceDetail: 256, //Bán TSCĐ chưa thu tiền
  FADecrementDetail: 253, // Đánh giá lại TSCĐ
  FAInvoiceFixedAssetDetail: 251, // Mua TSCĐ cố định chưa thanh toán (Hóa đơn mua TSCĐ)
  FAPurchaseIncrementDetail: [58, 108, 159], //Chuyển khoản mua TSCĐ, Phiếu chi mua TSCĐ, Chi tiền gửi mua TSCĐ
  FADepreciationDetail: 255, // Hao mòn TSCĐ
  FADevaluationDetail: 419, // khấu hao TSCĐ
  FATransferDetail: 257, // Điều chuyển tài sản cố định
  CAReceiptFixedAssetDetail: [103, 155], // Phiếu thu bán TSCĐ, Thu tiền gửi bán TSCĐ (dùng chung form detail)
  TACircularVATDeclarationDetail: 469, // Tờ Khai giá trị gia tăng
  OpeningSupplyEntryDetail: 602, // Nhập công cụ dụng cụ ban đầu
  TAEnterpriseIncomeTaxDetail: 470, // Tờ khai thuế thu nhập doanh nghiệp
  ReceiptDetail: 707, // biên lai
  ElectronicTicketDetail :708, //vé điện tử
  CAFundInventoryDetail: 115, // kiểm kê quỹ
};
